import axios from 'axios'
import { API_URL } from '../../../../constants'

export const getHideRequisite = (id: any) => {
  return axios.post(`${API_URL}/api/internal/requisite/hide/${id}`)
}
